import axios, { AxiosInstance, RawAxiosRequestHeaders } from "axios";
import { toast } from "react-toastify";
import { CustomStateHook } from "../Hooks/State.hook";
import getClientName from "../Hooks/getClientName";

const currentRoute = getClientName();

export const baseURL = process.env.REACT_APP_API_URL ?
    `${process.env.REACT_APP_API_URL}/${currentRoute}`
    :
    `http://localhost:8000/api/${currentRoute}`;

const api: AxiosInstance = axios.create({
    baseURL: baseURL,
    timeout: 300000,
});

export const schedulesApi: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_SCHEDULES_URL ?
        `${process.env.REACT_APP_SCHEDULES_URL}/${currentRoute}` :
        `http://localhost:7002/api/wa-schedules/${currentRoute}`,
    timeout: 300000
})

export type CustomRequestOptions<TResponseData, TRequestData> = {
    method: "get" | "post" | "patch" | "put" | "delete";
    endpoint: `/${string}`;
    params?: Record<string, any>;
    requestHeaders?: RawAxiosRequestHeaders;
    requestData?: TRequestData;
    onSuccess: (data: TResponseData) => void;
    onError?: (error: any) => void;
    loadingState?: CustomStateHook<boolean>;
    enableToast?: boolean;
    successToastMessage?: string;
    timeoutSeconds?: number
}

export type PaginatedResponse<T> = {
    data: Array<T>,
    page: {
        current: number;
        next: boolean;
        previous: boolean;
    }
}

async function customRequest<TResponseData, TRequestData>({
    method,
    endpoint,
    onSuccess,
    onError,
    loadingState,
    requestHeaders,
    params,
    requestData,
    enableToast,
    successToastMessage,
    timeoutSeconds = 20
}: CustomRequestOptions<TResponseData, TRequestData>): Promise<void> {
    try {
        loadingState && loadingState.set(true);

        let response: PaginatedResponse<TResponseData> | any;

        // Same key LoginContext writes; an undefined Authorization would drop the default header.
        const localToken = localStorage.getItem("@inPulse-web/token");
        const headers = { ...(localToken ? { Authorization: `Bearer ${localToken}` } : {}), ...requestHeaders };
        const timeout = timeoutSeconds * 1000;

        console.log("params", params)
        switch (method) {
            case "post":
                response = await api.post<PaginatedResponse<TResponseData>>(endpoint, requestData, { headers, params, timeout });
                break;
            case "patch":
                response = await api.patch<PaginatedResponse<TResponseData>>(endpoint, requestData, { headers, params, timeout });
                break;
            case "put":
                response = await api.put<PaginatedResponse<TResponseData>>(endpoint, requestData, { headers, params, timeout });
                break;
            case "delete":
                response = await api.delete<PaginatedResponse<TResponseData>>(endpoint, { headers, params, timeout });
                break;
            default:
                response = await api.get<PaginatedResponse<TResponseData>>(endpoint, { headers, params, timeout });
                break;
        }

        onSuccess(response.data);
        enableToast && successToastMessage && toast.success(successToastMessage);
    } catch (err: any) {
        console.error(err?.response ? err.response.data : err?.message);

        enableToast && toast.error(err.response ? err.response.data : err?.message);
        onError && onError(err);
    } finally {
        loadingState && loadingState.set(false);
    }
}

export default api;
export { customRequest }